import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { editUser } from "../api/user";
import PendingDataGrid from "../components/pendingDataGrid";
import UserMatchesGrid from "../components/userMatchesGrid";
import { TOAST_SETTINGS } from "../config/constants";
import useToastContext from "../config/useToastContext";
import { useGlobal } from "../context/GlobalProvider";
import { ScoutingSchedule } from "../components/schedule";
import { ScheduleManager } from "../components/scheduleManager";
import { fetchTeamData, fetchEventTeamData } from "../api/teamData";

async function EditUser(user) {
  try {
    const data = await editUser(user);
    if (!data?.body) throw new Error("Invalid API response");
    return data;
  } catch (error) {
    console.error("Error fetching users:", error);
    return { body: JSON.stringify({ data: [] }) };
  }
}

export default function Account({ user, signOut }) {
  const [tempUser, setTempUser] = useState(user);
  const addToast = useToastContext();
  const { setCurrentTab } = useGlobal();
  const [statBoticsData, setStatBoticsData] = useState([]);

  useEffect(() => {
    setCurrentTab("account");
  }, []);

  useEffect(() => {
    fetchTeamData(user.team_number, 2025)
      .then((data) => {
        setStatBoticsData(data);
        console.log(data.competing.next_event_key);
        if (data !== null) {
          console.log(data);
        }
      })
      .catch((error) => {
        if (error.name !== "AbortError") {
          console.error("Fetch error:", error);
        }
      });
  }, [user]);

  const handleStringChange = (name, event) => {
    let value = event?.target?.value ?? "";
    setTempUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const response = await EditUser(tempUser);
    if (response.statusCode === 200) {
      addToast({
        message: "Successfully Edited the User",
        severity: TOAST_SETTINGS.severity.SUCCESS,
      });
    } else {
      addToast({
        message: "There was an error editing the user",
        severity: TOAST_SETTINGS.severity.ERROR,
      });
    }
  };

  return (
    <>
      <Grid container sx={{ width: "100%" }} spacing={2}>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <Typography>
            <b>Personal Data</b>
          </Typography>
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            name="firstName"
            fullWidth
            label="First Name"
            variant="outlined"
            type="string"
            value={tempUser?.first_name || ""}
            InputLabelProps={{
              shrink: tempUser?.first_name ? true : false,
            }}
            onChange={(e) => handleStringChange("first_name", e)}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            name="lastName"
            fullWidth
            label="Last Name"
            variant="outlined"
            type="string"
            value={tempUser?.last_name || ""}
            InputLabelProps={{
              shrink: tempUser?.last_name ? true : false,
            }}
            onChange={(e) => handleStringChange("last_name", e)}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            name="email"
            fullWidth
            label="Email"
            variant="outlined"
            type="string"
            disabled={true}
            value={tempUser?.email || ""}
            InputLabelProps={{
              shrink: tempUser?.email ? true : false,
            }}
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                color: "#ffffff73",
                "-webkit-text-fill-color": "#ffffff73",
                opacity: 1,
              },
              "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#ffffff73",
                },
              "& .MuiInputLabel-root.Mui-disabled": {
                color: "#ffffff73",
              },
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <TextField
            name="teamNumber"
            fullWidth
            label="Team Number"
            variant="outlined"
            type="string"
            disabled={true}
            value={tempUser?.team_number || ""}
            InputLabelProps={{
              shrink: tempUser?.team_number ? true : false,
            }}
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                color: "#ffffff73", // This sets the default text color
                "-webkit-text-fill-color": "#ffffff73", // Override the default disabled text color
                opacity: 1, // Ensure the opacity is set correctly
              },
              "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "#ffffff73", // Optional: Change border color
                },
              "& .MuiInputLabel-root.Mui-disabled": {
                color: "#ffffff73", // Change the label color when disabled
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sx={{ textAlign: "right" }}>
          <Button variant="contained" onClick={() => handleSubmit()}>
            Update
          </Button>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 3 }} spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ textAlign: "center" }}>
            <b>My Data Entered</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <UserMatchesGrid user={user} />
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 3 }} spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ textAlign: "center" }}>
            <b>Schedule</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ScoutingSchedule
            user={user}
            event={statBoticsData?.competing?.next_event_key}
          />
        </Grid>
      </Grid>
      {(user.user_type === 1 || user.user_type === 2) && (
        <ScheduleManager
          user={user}
          currentEvent={statBoticsData?.competing?.next_event_key}
        />
      )}
      <Grid container sx={{ mt: 3 }} spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ textAlign: "center" }}>
            <b>Pending Users</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <PendingDataGrid user={user} />
        </Grid>
      </Grid>
    </>
  );
}
